/**
 * BlockPreview Surface Component
 * Preview panel for blocks
 */

import React from 'react';
import { Stack, Text, Badge, Paper, Group, ThemeIcon } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';

interface BlockPreviewProps {
  phase?: number;
}

const BlockPreview: React.FC<BlockPreviewProps> = ({ phase = 2 }) => {
  return (
    <Stack gap="md" p="sm">
      <Group justify="space-between" align="center">
        <Group gap="xs">
          <ThemeIcon variant="light" color="blue" size="sm">
            <IconEye size={14} />
          </ThemeIcon>
          <Text fw={600} size="sm">Block Preview</Text>
        </Group>
        <Badge size="xs" variant="light">Phase {phase}</Badge>
      </Group>

      <Paper p="md" radius="md" withBorder style={{ minHeight: 200 }}>
        <Text c="dimmed" size="sm" ta="center">
          Select a block to preview its content and properties
        </Text>
      </Paper>
    </Stack>
  );
};

export default BlockPreview;